import { AbstractControl, FormGroup, ValidationErrors } from '@angular/forms';

// Разрешаем спецсимволы и требуем домен (например, .ru/.com)
export const EMAIL_PATTERN = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+|".*?")@[a-zA-Z0-9-]+(?:\.[a-zA-Z-]+)+$/;

export const DIGIT_CHARACTERS_ONLY_PATTERN = /^[0-9]*$/;

export const DIGIT_CHARACTERS_PATTERN = /[0-9]+/;

export const CHARACTERS_PATTERN = /[a-zA-Z]+/;

export const RUSSIAN_CHARACTERS_PATTERN = /[а-яА-ЯёЁ]+/;

export class ExtendedCustomFormValidators {
  /**
   * Checks control's value with predefined email regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxInvalidEmail' validator error
   * @memberof CustomFormValidators
   */
  static emailValidator(control: AbstractControl): ValidationErrors | null {
    const email = control.value as string;

    return !email || EMAIL_PATTERN.test(email) ? null : { cxInvalidEmail: true };
  }

  /**
   * Checks control's value with predefined phone regexp
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)}  Uses 'invalidPhone' validator error
   * @memberof CustomFormValidators
   */
  static phoneValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    if (!value || value === '+7' || value === '7' || value === '+7 ' || value === '7 ') {
      return null;
    }

    const cleanValue = value.replace(/\D/g, '');
    if (cleanValue.length < 11) {
      return { invalidPhone: true };
    }

    if (cleanValue.length !== 11) {
      return { invalidPhone: true };
    }

    if (!cleanValue.startsWith('7')) {
      return { invalidPhone: true };
    }

    const firstDigitAfterSeven = cleanValue.charAt(1);
    if (!['3', '4', '8', '9'].includes(firstDigitAfterSeven)) {
      return { invalidPhone: true };
    }

    return null;
  }

  /**
   * Checks if control's value contains only digit characters
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxContainsNonDigitCharacters' validator error
   */
  static digitCharactersOnly(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string;

    return !value || DIGIT_CHARACTERS_ONLY_PATTERN.test(value) ? null : { cxContainsNonDigitCharacters: true };
  }

  /**
   * Checks if control's value contains digit characters
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxNotContainsDigitCharacters' validator error
   */
  static containsDigitCharacters(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string;

    return !value || DIGIT_CHARACTERS_PATTERN.test(value) ? null : { cxNotContainsDigitCharacters: true };
  }

  /**
   * Checks if control's value contains characters
   *
   * NOTE: Use it as a control validator
   *
   * @static
   * @param {AbstractControl} control
   * @returns {(ValidationErrors | null)} Uses 'cxNotContainsCharacters' validator error
   */
  static containsCharacters(control: AbstractControl): ValidationErrors | null {
    const value = control.value as string;

    return !value || (CHARACTERS_PATTERN.test(value) && !RUSSIAN_CHARACTERS_PATTERN.test(value))
      ? null
      : { cxNotContainsCharacters: true };
  }

  static passwordsMustMatch(password: string, passwordConfirmation: string): any {
    const validator = (formGroup: FormGroup): void =>
      controlsMustMatch(formGroup, password, passwordConfirmation, 'cxPasswordsMustMatch');

    return validator;
  }
}

export function controlsMustMatch(
  formGroup: FormGroup,
  firstControlName: string,
  secondControlName: string,
  errorName: string,
): void {
  const firstControl = formGroup.controls[firstControlName];
  const secondControl = formGroup.controls[secondControlName];

  if (secondControl.errors && !secondControl.errors[errorName]) {
    return;
  }

  secondControl.setErrors(firstControl.value !== secondControl.value ? { [errorName]: true } : null);
}
